import http from '../http.js'
import {
  AI_DUBBING_TASK_TYPE,
  buildDubbingCreatePayload,
} from '~/constants/aiDubbing.js'

export const AiDubbingApi = {
  CREATE_TASK: '/api/aigc/comprehensive/dubbing/create-task',
  GET_TASK_RESULT: '/api/aigc/comprehensive/dubbing/get-task-result',
  GET_HISTORY: '/api/aigc/comprehensive/dubbing/get-history',
  DELETE_TASK: '/api/aigc/comprehensive/dubbing/delete-task',
}

/**
 * @param {{
 *   generation_type?: string,
 *   video_url: string,
 *   target_language: string,
 *   duration: number,
 * }} params
 */
export function createAiDubbingTask(params) {
  return http.post(
    AiDubbingApi.CREATE_TASK,
    buildDubbingCreatePayload({
      generationType: params?.generation_type,
      videoUrl: params?.video_url,
      targetLanguage: params?.target_language,
      duration: params?.duration,
    }),
  )
}

/** @param {{ task_id: string }} params */
export const getAiDubbingTaskResult = (params) =>
  http.get(AiDubbingApi.GET_TASK_RESULT, params)

/**
 * @param {{ page?: number, size?: number, task_type?: string }} [params]
 */
export function getAiDubbingHistory(params = {}) {
  return http.get(AiDubbingApi.GET_HISTORY, {
    page: Number(params.page) || 1,
    size: Number(params.size) || 10,
    task_type: params.task_type ?? AI_DUBBING_TASK_TYPE,
  })
}

/** @param {{ task_ids: string[] }} data */
export const deleteAiDubbingTask = (data) =>
  http.post(AiDubbingApi.DELETE_TASK, data)
